import ajax from '@/modules/ajax';
import CreditCard from '@/modules/credit_card';
import Helper from '@/modules/helper';
import I18n from '@/modules/i18n';

export default class PaymentMethod {
  constructor(options) {
    this.form = document.querySelector('[data-form]');
    this.options = options;
  }

  create() {
    new CreditCard({ form: this.form, success: (formValidator) => this.save(formValidator) }).init();
  }

  save(formValidator) {
    // TODO: remove this modal from formValidator
    formValidator.showModal(I18n.t('checkout.loading_message'));

    ajax({
      done: this.success.bind(this),
      fail: (_notify, response) => formValidator.showErrors(response),
      form: this.form,
      method: this.options.save_verb || 'PATCH',
      url: this.options.save_uri,
    });
  }

  success(_json) {
    setTimeout(() => {
      Helper.goTo(this.options.success_uri);
    }, 1000);
  }
}
